import { CloseCircleOutlined } from '@ant-design/icons';
import { AccessCaseNotice } from '@prisma/client';
import { Button, Descriptions, DescriptionsProps, Modal } from 'antd';

import { EmailNoticeMeta } from '@app/domain-access-case-interfaces';

import { NoticeTemplateNameRenderer } from './notice-template-name-renderer';

export type NoticeModalProps = {
  notice: AccessCaseNotice | undefined;
  onClose: () => void;
};

export const NoticeModal = ({ notice, onClose }: NoticeModalProps) => {
  if (!notice) return undefined;

  const meta = notice.meta as EmailNoticeMeta;

  const items: DescriptionsProps['items'] = [
    {
      key: 'Subject',
      label: 'Subject',
      children: meta.subject,
    },
    {
      key: 'to',
      label: 'To',
      children: meta.to.join('; '),
    },
    {
      key: 'body',
      label: 'Body',
      children: meta.body,
    },
    {
      key: 'templateFileName',
      label: 'Template File Name',
      children: <NoticeTemplateNameRenderer name={meta.templateFileName} type="name-highlighted" />,
    },
  ];

  return (
    <Modal
      title="Case"
      centered
      width={800}
      styles={{
        body: {
          height: 600,
          overflow: 'auto',
        },
      }}
      open={!!notice}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose} icon={<CloseCircleOutlined />} type="primary">
          Close
        </Button>,
      ]}
    >
      <Descriptions column={1} items={items} />
    </Modal>
  );
};
